export type ILocationOnBoardState = {
    id: number;
    address: string;
    center_location: string;
    name: string;
    polygon_locations: null
}

export enum IBookingManagementActionTypes {
    FETCH_LOCATION_LIST_REQUEST = 'FETCH_LOCATION_LIST_REQUEST',
    FETCH_LOCATION_LIST_SUCCESS = 'FETCH_LOCATION_LIST_SUCCESS',
    FETCH_LOCATION_LIST_FAILURE = 'FETCH_LOCATION_LIST_FAILURE',

    FETCH_BOOKINGS_LIST_REQUEST = 'FETCH_BOOKINGS_LIST_REQUEST',
    FETCH_BOOKINGS_LIST_SUCCESS = 'FETCH_BOOKINGS_LIST_SUCCESS',
    FETCH_BOOKINGS_LIST_FAILURE = 'FETCH_BOOKINGS_LIST_FAILURE',

    FETCH_VEHICLS_SUMMARY_REQUEST = 'FETCH_VEHICLS_SUMMARY_REQUEST',
    FETCH_VEHICLS_SUMMARY_SUCCESS = 'FETCH_VEHICLS_SUMMARY_SUCCESS',
    FETCH_VEHICLS_SUMMARY_FAILURE = 'FETCH_VEHICLS_SUMMARY_FAILURE',

    FETCH_PASSENGERS_REQUEST = 'FETCH_PASSENGERS_REQUEST',
    FETCH_PASSENGERS_SUCCESS = 'FETCH_PASSENGERS_SUCCESS',
    FETCH_PASSENGERS_FAILURE = 'FETCH_PASSENGERS_FAILURE',

    FETCH_EMPLOYEE_BOOKINGS_LIST_REQUEST = 'FETCH_EMPLOYEE_BOOKINGS_LIST_REQUEST',
    FETCH_EMPLOYEE_BOOKINGS_LIST_SUCCESS = 'FETCH_EMPLOYEE_BOOKINGS_LIST_SUCCESS',
    FETCH_EMPLOYEE_BOOKINGS_LIST_FAILURE = 'FETCH_EMPLOYEE_BOOKINGS_LIST_FAILURE',

    ADD_BOOKING_SCHEDULE_REQUEST = 'ADD_BOOKING_SCHEDULE_REQUEST',
    ADD_BOOKING_SCHEDULE_SUCCESS = 'ADD_BOOKING_SCHEDULE_SUCCESS',
    ADD_BOOKING_SCHEDULE_FAILURE = 'ADD_BOOKING_SCHEDULE_FAILURE',
    RESET_BOOKING_SCHEDULE= 'RESET_BOOKING_SCHEDULE',

    CONFIRM_BOOKING_SCHEDULE_REQUEST = 'CONFIRM_BOOKING_SCHEDULE_REQUEST',
    CONFIRM_BOOKING_SCHEDULE_SUCCESS = 'CONFIRM_BOOKING_SCHEDULE_SUCCESS',
    CONFIRM_BOOKING_SCHEDULE_FAILURE = 'CONFIRM_BOOKING_SCHEDULE_FAILURE',
    RESET_CONFIRM_BOOKING= 'RESET_CONFIRM_BOOKING',

    FETCH_TRIP_ANALYTICS_REQUEST = 'FETCH_TRIP_ANALYTICS_REQUEST',
    FETCH_TRIP_ANALYTICS_SUCCESS = 'FETCH_TRIP_ANALYTICS_SUCCESS',
    FETCH_TRIP_ANALYTICS_FAILURE = 'FETCH_TRIP_ANALYTICS_FAILURE',
}
    
export type IBookingManagementActionCreator = {
    type: string;
    payload: any;
};